import React, { useEffect, useMemo, useState } from "react";
import { getLeaves, updateLeaveStatus } from "../../../api/api";
import ConfirmModal from "../../../components/ConfirmModal";
import SuccessModal from "../../../components/SuccessModal";
import { useNavigate } from "react-router-dom";
export default function PendingTab() {
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const [btnLoadingId, setBtnLoadingId] = useState(null);
  const [confirmLoading, setConfirmLoading] = useState(false);

  const [filters, setFilters] = useState({
    search: "",
    type: "All",
  });

  const [confirmOpen, setConfirmOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  const [successOpen, setSuccessOpen] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  useEffect(() => {
    const handlePopState = () => {
      // If no proper history then redirect home
      if (window.history.length <= 1) {
        navigate("/", {
          replace: true,
        });
      }
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [navigate]);

  useEffect(() => {
    fetchLeaves();
  }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, [filters]);

  const fetchLeaves = async () => {
    setLoading(true);

    const res = await getLeaves();

    const formatted = res
      .filter((l) => l.status === "pending")
      .reverse()
      .map((l) => ({
        id: l.id,

        // FIXED
        type:
          l.leave_type?.name ||
          l.leave_type_name ||
          (l.leave_category
            ? `${l.leave_category
                .charAt(0)
                .toUpperCase()}${l.leave_category.slice(1)} Leave`
            : "General Leave"),

        from: l.from_date,

        to: l.to_date,

        days: l.days,

        reason: l.reason,
      }));

    setData(formatted);
    setLoading(false);
  };


  useEffect(() => {

  const refreshLeaves = () => {

    fetchLeaves();
  };

  window.addEventListener(
    "leave-updated",
    refreshLeaves
  );

  return () => {

    window.removeEventListener(
      "leave-updated",
      refreshLeaves
    );
  };

}, []);

  const filtered = useMemo(() => {
    return data.filter((item) => {
      const matchSearch =
        !filters.search ||
        item.reason.toLowerCase().includes(filters.search.toLowerCase());

      const matchType = filters.type === "All" || item.type === filters.type;

      return matchSearch && matchType;
    });
  }, [data, filters]);

  const totalPages = Math.ceil(filtered.length / itemsPerPage);

  const paginatedData = useMemo(() => {
    const start = (currentPage - 1) * itemsPerPage;
    return filtered.slice(start, start + itemsPerPage);
  }, [filtered, currentPage]);

  const canWithdraw = () => {
    const today = new Date();
    return today.getDate() <= 26;
  };

  const handleWithdraw = (id) => {
    if (!canWithdraw()) {
      setErrorMsg("Cannot be withdrawn after 26th of this month");
      return;
    }

    setErrorMsg("");
    setSelectedId(id);
    setConfirmOpen(true);
  };

  return (
    <div style={styles.container}>
      {/* HEADER */}
      <div style={styles.headerRow}>
        <div style={styles.title}>Pending Leave Requests</div>
      </div>

      {errorMsg && <div style={styles.errorText}>{errorMsg}</div>}

      {/* FILTERS */}
      <div style={styles.filterRow}>
        <input
          placeholder="Search reason"
          value={filters.search}
          onChange={(e) =>
            setFilters({
              ...filters,
              search: e.target.value,
            })
          }
          style={styles.input}
        />

        <select
          value={filters.type}
          onChange={(e) =>
            setFilters({
              ...filters,
              type: e.target.value,
            })
          }
          style={styles.input}
        >
          <option>All</option>
          <option>Loss of Pay</option>
          <option>Sick Leave</option>
          <option>Planned Leave</option>
          <option>Unplanned Leave</option>
        </select>
      </div>

      {/* CONTENT */}
      {loading ? (
        <div style={styles.emptyCard}>Loading...</div>
      ) : filtered.length === 0 ? (
        <div style={styles.emptyCard}>No pending requests</div>
      ) : (
        <>
          {/* ================= DESKTOP TABLE ================= */}
          <div className="desktopTable" style={styles.tableCard}>
            <table style={styles.table}>
              <thead>
                <tr>
                  <th style={styles.thLeft}>Type</th>
                  <th style={styles.th}>From</th>
                  <th style={styles.th}>To</th>
                  <th style={styles.th}>Days</th>
                  <th style={styles.thLeft}>Reason</th>
                  <th style={styles.th}>Action</th>
                </tr>
              </thead>

              <tbody>
                {paginatedData.map((item) => (
                  <tr key={item.id}>
                    <td style={styles.tdLeft}>{item.type}</td>
                    <td style={styles.td}>{item.from}</td>
                    <td style={styles.td}>{item.to}</td>
                    <td style={styles.td}>{item.days}</td>
                    <td style={styles.tdLeft}>{item.reason}</td>

                    <td style={styles.td}>
                      <button
                        style={styles.withdrawBtn}
                        onClick={() => handleWithdraw(item.id)}
                        disabled={btnLoadingId === item.id}
                      >
                        {btnLoadingId === item.id ? (
                          <div style={styles.spinner}></div>
                        ) : (
                          "Withdraw"
                        )}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* ================= MOBILE CARD LAYOUT ================= */}
          <div className="mobileCards">
            {paginatedData.map((item) => (
              <div key={item.id} style={styles.mobileCard}>
                <div style={styles.mobileTop}>
                  <div style={styles.leaveType}>{item.type}</div>

                  <div style={styles.daysBadge}>
                    {item.days} Day
                    {item.days > 1 ? "s" : ""}
                  </div>
                </div>

                <div style={styles.mobileRow}>
                  <span style={styles.mobileLabel}>From</span>
                  <span style={styles.mobileValue}>{item.from}</span>
                </div>

                <div style={styles.mobileRow}>
                  <span style={styles.mobileLabel}>To</span>
                  <span style={styles.mobileValue}>{item.to}</span>
                </div>

                <div style={styles.reasonBox}>
                  <div style={styles.reasonTitle}>Reason</div>

                  <div style={styles.reasonText}>{item.reason}</div>
                </div>

                <button
                  style={styles.mobileWithdrawBtn}
                  onClick={() => handleWithdraw(item.id)}
                  disabled={btnLoadingId === item.id}
                >
                  {btnLoadingId === item.id ? (
                    <div style={styles.spinner}></div>
                  ) : (
                    "Withdraw Request"
                  )}
                </button>
              </div>
            ))}
          </div>

          {/* PAGINATION */}
          <div style={styles.pagination}>
            <button
              style={{
                ...styles.pageBtn,
                opacity: currentPage === 1 ? 0.5 : 1,
              }}
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            >
              ◀
            </button>

            <div style={styles.pageText}>
              {currentPage} / {totalPages}
            </div>

            <button
              style={{
                ...styles.pageBtn,
                opacity: currentPage === totalPages ? 0.5 : 1,
              }}
              disabled={currentPage === totalPages}
              onClick={() =>
                setCurrentPage((prev) => Math.min(prev + 1, totalPages))
              }
            >
              ▶
            </button>
          </div>
        </>
      )}

      <ConfirmModal
        open={confirmOpen}
        title="Withdraw Leave"
        message="Are you sure you want to withdraw this leave application?"
        confirmText="Withdraw"
        confirmLoading={confirmLoading}
        onCancel={() => setConfirmOpen(false)}
        onConfirm={async () => {
          setConfirmLoading(true);
          setBtnLoadingId(selectedId);

          await updateLeaveStatus(selectedId, "withdrawn");

          setConfirmLoading(false);
          setBtnLoadingId(null);

          setConfirmOpen(false);
          setSuccessOpen(true);

          fetchLeaves();
        }}
      />

      <SuccessModal
        open={successOpen}
        message="Leave withdrawn successfully"
        onClose={() => setSuccessOpen(false)}
      />
    </div>
  );
}

const styles = {
  container: {
    padding: "14px",
  },

  headerRow: {
    marginBottom: "14px",
  },

  title: {
    fontSize: "20px",
    fontWeight: "700",
    color: "#111827",
  },

  errorText: {
    background: "#FEE2E2",
    color: "#DC2626",
    padding: "10px",
    borderRadius: "8px",
    marginBottom: "14px",
    fontSize: "13px",
  },

  filterRow: {
    display: "flex",
    gap: "10px",
    flexWrap: "wrap",
    marginBottom: "16px",
  },

  input: {
    flex: "1 1 220px",
    padding: "11px 14px",
    border: "1px solid #D1D5DB",
    borderRadius: "10px",
    fontSize: "14px",
    outline: "none",
    background: "#fff",
  },

  tableCard: {
    background: "#fff",
    borderRadius: "12px",
    overflowX: "auto",
    border: "1px solid #E5E7EB",
  },

  table: {
    width: "100%",
    borderCollapse: "collapse",
    minWidth: "800px",
  },

  th: {
    padding: "14px",
    background: "#F9FAFB",
    textAlign: "center",
    fontSize: "13px",
    color: "#6B7280",
    borderBottom: "1px solid #E5E7EB",
  },

  thLeft: {
    padding: "14px",
    background: "#F9FAFB",
    textAlign: "left",
    fontSize: "13px",
    color: "#6B7280",
    borderBottom: "1px solid #E5E7EB",
  },

  td: {
    padding: "14px",
    textAlign: "center",
    fontSize: "14px",
    borderBottom: "1px solid #F3F4F6",
  },

  tdLeft: {
    padding: "14px",
    textAlign: "left",
    fontSize: "14px",
    borderBottom: "1px solid #F3F4F6",
  },

  withdrawBtn: {
    background: "#111827",
    color: "#fff",
    border: "none",
    padding: "8px 14px",
    borderRadius: "8px",
    cursor: "pointer",
    fontSize: "13px",
    fontWeight: "600",
  },

  emptyCard: {
    background: "#fff",
    border: "1px solid #E5E7EB",
    borderRadius: "12px",
    padding: "40px",
    textAlign: "center",
    fontSize: "14px",
    color: "#6B7280",
  },

  mobileCard: {
    background: "#fff",
    border: "1px solid #E5E7EB",
    borderRadius: "16px",
    padding: "16px",
    marginBottom: "14px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
  },

  mobileTop: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "16px",
  },

  leaveType: {
    fontSize: "15px",
    fontWeight: "700",
    color: "#111827",
  },

  daysBadge: {
    background: "#EEF2FF",
    color: "#4338CA",
    padding: "6px 10px",
    borderRadius: "999px",
    fontSize: "12px",
    fontWeight: "600",
  },

  mobileRow: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "10px",
  },

  mobileLabel: {
    fontSize: "13px",
    color: "#6B7280",
    fontWeight: "500",
  },

  mobileValue: {
    fontSize: "13px",
    color: "#111827",
    fontWeight: "600",
  },

  reasonBox: {
    background: "#F9FAFB",
    borderRadius: "10px",
    padding: "12px",
    marginTop: "14px",
    marginBottom: "16px",
  },

  reasonTitle: {
    fontSize: "12px",
    fontWeight: "700",
    marginBottom: "6px",
    color: "#374151",
  },

  reasonText: {
    fontSize: "13px",
    color: "#4B5563",
    lineHeight: "20px",
  },

  mobileWithdrawBtn: {
    width: "100%",
    border: "none",
    background: "#111827",
    color: "#fff",
    padding: "12px",
    borderRadius: "10px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
  },

  pagination: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "14px",
    marginTop: "18px",
  },

  pageBtn: {
    width: "36px",
    height: "36px",
    borderRadius: "8px",
    border: "1px solid #D1D5DB",
    background: "#fff",
    cursor: "pointer",
  },

  pageText: {
    fontSize: "14px",
    fontWeight: "600",
  },

  spinner: {
    width: "16px",
    height: "16px",
    border: "2px solid #fff",
    borderTop: "2px solid transparent",
    borderRadius: "50%",
    animation: "spin 0.7s linear infinite",
    margin: "auto",
  },
};

const style = document.createElement("style");

style.innerHTML = `
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.mobileCards {
  display: none;
}

@media (max-width: 768px) {
  .desktopTable {
    display: none;
  }

  .mobileCards {
    display: block;
  }
}
`;

document.head.appendChild(style);
